import { ConnectorNames } from '@pancakeswap-libs/uikit'
import { Web3Provider } from '@ethersproject/providers'
import { InjectedConnector } from '@web3-react/injected-connector'
import { WalletLinkConnector } from '@web3-react/walletlink-connector'
import { BscConnector } from '@binance-chain/bsc-connector'
import { NetworkConnector } from './NetworkConnector'

const NETWORK_URL = process.env.REACT_APP_NETWORK_URL

export const NETWORK_CHAIN_ID: number = parseInt(process.env.REACT_APP_CHAIN_ID ?? '97')

if (typeof NETWORK_URL === 'undefined') {
  throw new Error(`REACT_APP_NETWORK_URL must be a defined environment variable`)
}

export const SUPPORTED_CHAIN_IDS = [56, 97]

export const network = new NetworkConnector({
  urls: { [NETWORK_CHAIN_ID]: NETWORK_URL },
})

let networkLibrary: Web3Provider | undefined
export function getNetworkLibrary(): Web3Provider {
  // eslint-disable-next-line no-return-assign
  return (networkLibrary = networkLibrary ?? new Web3Provider(network.provider as any))
}

/**
 * Legacy single-slot injected connector. Kept as the fallback for wallets that have
 * not adopted EIP-6963 yet - the discovery-based connectors in `./eip6963` are
 * preferred when available, because they can target a specific wallet rather than
 * whichever extension happened to win the `window.ethereum` race.
 */
export const injected = new InjectedConnector({
  supportedChainIds: SUPPORTED_CHAIN_IDS,
})

export const bscConnector = new BscConnector({ supportedChainIds: SUPPORTED_CHAIN_IDS })

/**
 * Coinbase Wallet. Uses WalletLink, which is Coinbase's own protocol - it is not
 * an injected wallet and does not participate in EIP-6963 discovery, so it is
 * always offered as an explicit option rather than being discovered.
 */
export const walletlink = new WalletLinkConnector({
  url: NETWORK_URL,
  appName: 'LiberaDex',
  appLogoUrl: `${window.location.origin}/images/libera-logo.png`,
})

/**
 * WalletConnect v2 requires a WalletConnect Cloud Project ID. v1 was removed from
 * this app when its bridge servers were shut down, and was never replaced - so
 * until a Project ID is supplied, WalletConnect is surfaced as explicitly
 * unavailable rather than as a button that silently does nothing.
 *
 * See TODO_CONFIG.md -> "Wallet / connection layer".
 */
export const WALLETCONNECT_PROJECT_ID = process.env.REACT_APP_WALLETCONNECT_PROJECT_ID
export const isWalletConnectConfigured = Boolean(WALLETCONNECT_PROJECT_ID)

/**
 * Retained for the UIKit's own Menu/WalletModal, which types its callback as
 * `ConnectorNames` and only knows about three connector ids. The app's own wallet
 * modal (components/WalletModal) is not limited to these.
 */
export const connectorsByName: { [connectorName in ConnectorNames]?: any } = {
  [ConnectorNames.Injected]: injected,
  [ConnectorNames.BSC]: bscConnector,
}
